export const all_routes = {
  dashboard: "/",
  comperitiveDashboard1:"/comparative_dashboard/1",
  comperitiveDashboard2:"/comparative_dashboard/2",
  signin: "/signin",
  company: "/company",
  dynamicpage: "/RepOpt/:id",
  dynamiclist: "/RepList/:id",
  voucherList: "/V-10001",
  order: "/order",
  purchase: "/purchase",
  receipt: "/receipt",
  // =============user===============
  userlist: "/userlist",
  userpage: "/createuser",
  catalogue: "/catalogue/:id",
  custsupplogin: "/custsupplogin",
};
